import { gql } from "apollo-boost"

export default gql`
  query ShoppingCartDropdown {
    shoppingCart {
      id
      status
      orderDetails {
        quantity
        unitPrice
        product {
          id
          name
          photoUrl
        }
      }
    }
  }
`
